var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.modules),function(module,index){return _c('div',{key:`card-module-${module.id}${index}`,staticClass:"col-md-3 mb-4 position-relative"},[_c('CardModule',{attrs:{"module":module,"index-module":index},on:{"edit-module":_vm.editModule}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }